import UiButton from '@/ui/UiButton/UiButton';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Buttons() {
  const navigate = useNavigate();

  return (
    <div className="page">
      <div className="article">
        <h1 className="article-title">Кнопки ГИД</h1>
        <div className="article-body">
          <p>
            Чтобы добавить кнопку <strong>&laquo;Войти с ГИД&raquo;</strong> в ваше приложение,
            в свойство <strong>buttons</strong> (массив объектов) в конфигурации SDK
            необходимо добавить объект, описывающий её параметры.
          </p>
          <p>Кнопка имеет три строковых параметра:</p>
          <ul className="article-list">
            <li>
              <strong>container:</strong> определяет CSS-селектор контейнера кнопки
              (например, &apos;#button1&apos;)
            </li>
            <li>
              <strong>type:</strong> определяет тип кнопки (&apos;standard&apos;,
              &apos;compact&apos;, &apos;iconic&apos;)
            </li>
            <li>
              <strong>color:</strong> определяет цвет кнопки (&apos;primary&apos;,
              &apos;secondary&apos;, &apos;dark&apos;)
            </li>
          </ul>

          <div className="article-examples">
            <div data-text="standard, primary" className="article-example" id="button1" />
            <div data-text="compact, primary" className="article-example" id="button2" />
            <div data-text="iconic, primary" className="article-example" id="button3" />
            <div data-text="standard, secondary" className="article-example" id="button4" />
            <div data-text="compact, secondary" className="article-example" id="button5" />
            <div data-text="iconic, secondary" className="article-example" id="button6" />
            <div data-text="standard, dark" className="article-example" id="button7" />
            <div data-text="compact, dark" className="article-example" id="button8" />
            <div data-text="iconic, dark" className="article-example" id="button9" />
          </div>
        </div>
        <UiButton
          type='flat'
          size='small'
          className='index-element-1'
          onClick={() => navigate('/')}
        >
          Назад
        </UiButton>
      </div>
    </div>
  );
}
